import {connect} from 'react-redux';
import {actions} from '../../../js/redux/salesReport';
import ContainerReport from './ContainerReport';

const managementReport = (state) => {
  return {
    ...state.salesReport,
  };
};


const ManagementReportConn =  connect(managementReport, actions)(ContainerReport);
export {
  ManagementReportConn
}